import { withRouter } from 'react-router-dom';
import LoginFormComponent from './LoginForm';

export const LoginForm = LoginFormComponent;
export default withRouter(LoginForm);
